import React from 'react'
import img1 from "../../assets/image 4.png"
import img2 from "../../assets/altalogo.png"
import img3 from "../../assets/HngLogo.png"
import img4 from "../../assets/SIHlogo.png"
import img5 from "../../assets/image 8.png"
import img6 from "../../assets/image 9.jpg"
import img7 from "../../assets/image 6.png"
import img8 from "../../assets/image 7.png"
import img9 from "../../assets/image 5.png"
import "./workedCompanies.css"

const workedCompanies = () => {
  return (
    <div className='py-5'>
      <h5 className='text-white text-2xl md:text-3xl py-4 font-bold text-center md:text-left'>I have worked with...</h5>
      <div className='work-container md:flex items-center justify-between space-x-2  hidden '>
        <div className='img-containers'><img src={img2} alt="" /></div>
        <div className='img-containers'><img src={img1} alt="" /></div>
        <div className='img-containers'><img src={img3} alt="" /></div>
        <div className='img-containers'><img src={img5} alt="" /></div>
        <div className='img-containers'><img src={img4} alt="" /></div>
        <div className='img-containers'><img src={img6} alt="" /></div>
      </div>
      <div className='md:hidden  work-containers items-center justify-between space-x-2'>
        <div className='img-container'><img src={img9} alt="" /></div>
      <div className='img-container'><img src={img1} alt="" /></div>
        <div className='img-container'><img src={img7} alt="" /></div>
        <div className='img-container'><img src={img8} alt="" /></div>
        <div className='img-container'><img src={img5} alt="" /></div>
        <div className='img-container'><img src={img6} alt="" /></div>
      </div>
    </div>
  )
}

export default workedCompanies
